import { useI18n } from 'utils/i18n';

interface Props {
	className?: string;
	quantity: number;
}

export default function QuantityLabel({ className, quantity }: Props) {
	const { t } = useI18n();
	return (
		<p className={className}>
			{t('general_quantity_label')}:{' '}
			<span className="ml-1 inline-block rounded-xs border border-subtle px-2 py-1 font-bold">
				{t('general_amount_label', { amount: quantity })}
			</span>
		</p>
	);
}
QuantityLabel.displayName = 'QuantityLabel';
